import {
  GET_USER,
  GET_USERSLIST,
  GET_SCHOOL,
  GET_SCHOOLSLIST,
  CLEAR_SCHOOL,
  GET_RESULTS,
  CLEAR_USER,
  GET_ASSESSMENT,
  GET_ASSESSMENTSLIST,
  CLEAR_ASSESSMENT,
  CLEAR_ASSESSMENT_GROUP,
  CLEAR_ADMIN,
  CLEAR_ITEMS,
  GET_RESULT,
  CLEAR_RESULT,
  GET_PMRESULTS,
  GET_PMRESULT,
  CLEAR_PMRESULT,
  CLEAR_CLASSROOM,
  GET_CLASSROOMSLIST,
  CLEAR_RESULT_LIST,
  GET_CLASSROOMSSTUDENTLIST,
  GET_CLASSROOM,
  GET_REPORT,
  CLEAR_REPORT,
  GET_COMPARE_REPORT,
  CLEAR_COMPARE_REPORT,
  LOGOUT,
  GET_ASSESSMENTINSTRUCTION,
  GET_OVERALL_RESULTS_CHART,
  GET_OVERALL_RESULTS_BY_ASSESSMENT_CHART,
  GET_OVERALL_RESULTS_PROGRESSION_CHART,
  GET_AVERAGE_SCORE_BENCHMARK_CATEGORY_CHART,
  GET_AVERAGE_SCORE_BENCHMARK_CATEGORY_CHART2,
  GET_OVERALL_RESULTS_CHARTS,
  GET_OVERALL_RESULTS_BY_ASSESSMENT_CHARTS,
  GET_OVERALL_RESULTS_PROGRESSION_CHARTS,
  GET_SCHOOL_YEARS,
  CLEAR_SCHOOL_YEARS,
  GET_ASSESSMENT_GROUP,
} from "../actions/types";
import { setAlert } from "./alerts";
import { clearAssessmentResult } from "./assessment";
import api from "../utils/api";
import { getSchoolYears } from "../utils/getSchoolYears";
import { getCancelSource, clearCancelSource } from "../utils/requestManager";

export const updateInstructionsImage =
  (data = {}) =>
  async (dispatch) => {
    try {
      const res = await api.put(`/auth/instruction`, data);
      dispatch(setAlert("Instruction image updated successfully", "success"));
      return res?.data;
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const getInstructionsImage = () => async (dispatch) => {
  try {
    const res = await api.get(`/auth/instruction`);
    const image = res?.data?.data;
    dispatch({
      type: "GET_INSTRUCTIONS_IMAGE",
      payload: image,
    });

    return image;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const setUser = (user) => (dispatch) => {
  dispatch({ type: GET_USER, payload: user });
};

export const getUser = (id) => async (dispatch) => {
  try {
    const res = await api.post("/users/get", { UserID: parseInt(id) });
    dispatch({ type: GET_USER, payload: res?.data?.data[0] });
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const validateUser = (data) => async (dispatch) => {
  try {
    const res = await api.post("/users/validate", data);

    return res?.data;
  } catch (error) {
    const errors = error?.response?.data?.errors;

    if (errors) {
      if (errors["Summary"] === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else return error?.response?.data;
    }
  }
};

export const loadUsersList =
  (formData = {}) =>
  async (dispatch) => {
    const source = getCancelSource("loadUsersList");
    try {
      const res = await api.post("/users/get", formData, {
        cancelToken: source.token,
      });
      dispatch({ type: GET_USERSLIST, payload: res?.data?.data });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    } finally {
      clearCancelSource(loadUsersList, source);
    }
  };

export const updateUser = (userId, formData) => async (dispatch) => {
  try {
    await api.put(`/users/${userId}`, formData);
    dispatch(setAlert("User Updated Successfully", "success"));
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const addUser = (formData) => async (dispatch) => {
  try {
    if (formData.UserTypeID === "5") {
      formData = { ...formData, SchoolID: null };
    }

    await api.post("/users", formData);
    dispatch(setAlert("User Added Successfully", "success"));
  } catch (err) {
    const errors = err?.response?.data?.errors;

    if (errors) {
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error?.message, "danger")));
    }
  }
};

export const importUsers = (formData) => async (dispatch) => {
  try {
    const response = await api.post("/users/import", formData);
    dispatch(setAlert("Users Imported", "success"));
    return response.data;
  } catch (err) {
    const errors = err?.response?.data?.errors;

    if (errors) {
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error?.message, "danger")));
    }
    return err?.response?.data || err;
  }
};

export const deleteUser = (userId) => async (dispatch) => {
  try {
    await api.delete(`/users/${userId}`);
    dispatch(setAlert("User Deleted Successfully", "info"));
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const deleteMultipleUsers =
  (userIds, filterData) => async (dispatch) => {
    try {
      await api.delete(`/users/delete`, { data: { userIds } });
      dispatch(loadUsersList(filterData));
      dispatch(setAlert("Users Deleted Successfully", "info"));
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const setSchool = (school) => (dispatch) => {
  dispatch({ type: GET_SCHOOL, payload: school });
};

export const getSchool = (id) => async (dispatch) => {
  try {
    const res = await api.post("/schools/get", { SchoolID: parseInt(id) });

    dispatch({ type: GET_SCHOOL, payload: res?.data?.data[0] });
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const loadSchoolsList =
  (value = {}) =>
  async (dispatch) => {
    const source = getCancelSource("loadSchoolsList");
    try {
      const res = await api.post("/schools/get", value, {
        cancelToken: source.token,
      });
      dispatch({ type: GET_SCHOOLSLIST, payload: res?.data?.data });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    } finally {
      clearCancelSource("loadSchoolsList", source);
    }
  };

export const updateSchool = (schoolId, formData) => async (dispatch) => {
  try {
    const result = await api.put(`/schools/${schoolId}`, formData);
    dispatch(loadSchoolsList());
    dispatch(setAlert("School updated Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err?.response?.data?.errors;

    if (errors) {
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error?.message, "danger")));
    }
  }
};

export const addSchool = (formData) => async (dispatch) => {
  try {
    await api.post("/schools", formData);
    dispatch(loadSchoolsList());
    dispatch(setAlert("School Added Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err?.response?.data?.errors;

    if (errors) {
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error?.message, "danger")));
    }
  }
};
export const importSchools = (formData) => async (dispatch) => {
  try {
    await api.post("/schools/import", formData);
    dispatch(loadSchoolsList());
  } catch (err) {
    const errors = err?.response?.data?.errors;

    if (errors) {
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error?.message, "danger")));
    }
    console.log(err);
  }
};

export const deleteSchool = (schoolId) => async (dispatch) => {
  try {
    await api.delete(`/schools/${schoolId}`);
    dispatch(loadSchoolsList());
    dispatch(setAlert("School Deleted Successfully", "info"));
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

// delete multiple schools
export const deleteMultipleSchools = (schoolIds) => async (dispatch) => {
  try {
    await api.delete("/schools/delete", { data: { schoolIds } });
    dispatch(loadSchoolsList());
    dispatch(setAlert("Schools Deleted Successfully", "info"));
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const loadAssessmentsList =
  (payload = {}) =>
  async (dispatch) => {
    const source = getCancelSource("loadAssessmentsList");
    try {
      // Pass payload directly as req.body
      const res = await api.post(`/assessments/all`, payload, {
        cancelToken: source.token,
      });
      dispatch({ type: GET_ASSESSMENTSLIST, payload: res.data.data });
    } catch (error) {
      console.error(error);
      const errors = error?.response?.data?.errors;
      if (errors && errors[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
    } finally {
      clearCancelSource("loadAssessmentsList", source);
    }
  };

export const loadAssessmentsListBySchoolAssessment =
  (schoolID) => async (dispatch) => {
    try {
      const res = await api.get(
        `/assessments/school/assessment?schoolID=${schoolID}`,
      );
      dispatch({ type: GET_ASSESSMENTSLIST, payload: res?.data?.data });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const getAssessment = (id, CategoryID) => async (dispatch) => {
  try {
    const res = await api.post(`/assessments/get/${id}`, {
      CategoryID: parseInt(CategoryID),
    });
    dispatch({ type: CLEAR_ASSESSMENT_GROUP });
    dispatch({ type: GET_ASSESSMENT, payload: res?.data?.data });
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const getAssessmentInstructionByCategoryID =
  (CategoryID) => async (dispatch) => {
    try {
      const res = await api.get(`/assessments/getinstruction/${CategoryID}`);
      dispatch({ type: GET_ASSESSMENTINSTRUCTION, payload: res?.data?.data });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const getAssessmentGroup = (assessments) => async (dispatch) => {
  try {
    const results = await Promise.all(
      assessments.map(({ AssessmentID, CategoryID }) =>
        api.post(`/assessments/get/${AssessmentID}`, {
          CategoryID: parseInt(CategoryID),
        }),
      ),
    );
    const data = results.map((res) => res?.data?.data);

    dispatch({ type: GET_ASSESSMENT_GROUP, payload: data });
    // Keep `assessment` populated with the first record so the existing
    // single-assessment initializers (getInitialFormData, benchmark
    // defaults, the edit-mode Redirect check) keep working unchanged.
    dispatch({ type: GET_ASSESSMENT, payload: data[0] });
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors && errors?.[0]?.msg === "Session Expired") {
      dispatch({ type: LOGOUT });
      dispatch(clearAll());
    }
  }
};

export const clearAssessmentGroup = () => (dispatch) => {
  dispatch({ type: CLEAR_ASSESSMENT_GROUP });
};

export const updateAssessment =
  (assessmentId, formData) => async (dispatch) => {
    try {
      const data = { ...formData, SchoolsID: [...new Set(formData.SchoolsID)] };
      await api.put(`/assessments/${assessmentId}`, data);
      // dispatch(loadAssessmentsList());
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const deleteAssessment =
  (assessmentId, CategoryID) => async (dispatch) => {
    try {
      await api.delete(`/assessments/all/${assessmentId}`, {
        data: {
          CategoryID,
        },
      });
      dispatch(loadAssessmentsList());
      dispatch(setAlert("Assessment Deleted Successfully", "info"));
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

// export const deleteMultipleAssessments =
//   (assessmentDetails) => async (dispatch) => {
//     try {
//       await api.delete(`/assessments/all/delete`, {
//         data: {
//           assessmentDetails,
//         },
//       });
//       dispatch(loadAssessmentsList());
//       dispatch(setAlert("Assessments Deleted Successfully", "info"));
//     } catch (error) {
//       console.log(error);
//       const errors = error?.response?.data?.errors;
//       if (errors)
//         if (errors?.[0]?.msg === "Session Expired") {
//           dispatch({ type: LOGOUT });
//           dispatch(clearAll());
//         }
//     }
//   };

export const deleteMultipleAssessments =
  (selectedAssessments, defaultAssessments) => async (dispatch) => {
    try {
      // 1. Group assessments by their CategoryID dynamically
      const groups = selectedAssessments.reduce((acc, item) => {
        const catId = item.CategoryID;
        if (!acc[catId]) acc[catId] = [];

        // Only map the exact fields your SQL SP expects
        acc[catId].push({
          AssessmentID: item.AssessmentID,
          SchoolID: item.SchoolID,
        });
        return acc;
      }, {});

      // 2. Fire an API request for each distinct category group found
      const deletePromises = Object.keys(groups).map((catId) =>
        api.delete(`/assessments/all/delete`, {
          data: {
            assessmentDetails: groups[catId],
            CategoryID: Number(catId), // Ensure it passes as a numeric ID
          },
        }),
      );

      // Wait for all bulk operations to finish
      await Promise.all(deletePromises);

      dispatch(loadAssessmentsList(defaultAssessments));
      dispatch(setAlert("Assessments Deleted Successfully", "info"));
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors && errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
    }
  };

export const addAssessment = (formData) => async (dispatch) => {
  try {
    const data = { ...formData, SchoolsID: [...new Set(formData.SchoolsID)] };
    await api.post("/assessments", data);
    // dispatch(loadAssessmentsList());
    dispatch(setAlert("Assessment Added Successfully", "success"));
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const setAssessment = (assessment) => (dispatch) => {
  dispatch({ type: GET_ASSESSMENT, payload: assessment });
};

export const importAssessments = (formData) => async (dispatch) => {
  try {
    await api.post("/assessments/import", formData);
    dispatch(loadAssessmentsList());
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const addSchoolAssessment = (formData) => async (dispatch) => {
  try {
    await api.post("/assessments/school", formData);
    dispatch(getAssessment(formData.AssessmentID, formData.CategoryID));
    dispatch(setAlert("Assessment Added to School Successfully", "success"));
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const deleteSchoolAssessment =
  (assessmentId, CategoryID, SchoolID) => async (dispatch) => {
    try {
      await api.delete(`/assessments/school/${SchoolID}/${assessmentId}`, {
        data: {
          CategoryID,
        },
      });
      dispatch(getAssessment(assessmentId, CategoryID));
      dispatch(setAlert("Assessment Deleted from School Successfully", "info"));
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const setResult = (result) => (dispatch) => {
  dispatch({ type: GET_RESULT, payload: result });
};

export const getResult = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/assessmentresults/${id}`);
    dispatch({ type: GET_RESULT, payload: res?.data?.data?.results });
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const generateReport = (payload) => async (dispatch) => {
  try {
    // const res = await api.get(
    //   `/assessmentresults/reports/${year}/${benchmarkID}/${schoolID}/${gradeID}/${sectionID}/${studentID}/${teacherID}/${schoolIds}`,
    // );
    const res = await api.post(`/assessmentresults/reports/`, payload);

    dispatch({ type: GET_REPORT, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const generateCompareReport =
  (
    year,
    benchmarkID,
    schoolID,
    gradeID,
    sectionID,
    studentID,
    teacherID,
    schoolIds,
  ) =>
  async (dispatch) => {
    try {
      const res = await api.get(
        `/assessmentresults/comparereports/${year}/${benchmarkID}/${schoolID}/${gradeID}/${sectionID}/${studentID}/${teacherID}/${schoolIds}`,
      );

      dispatch({ type: GET_COMPARE_REPORT, payload: res.data.data });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors[0].msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const getChartOverallResults =
  (
    year,
    benchmarkID,
    schoolID,
    gradeID,
    sectionID,
    studentID,
    teacherID,
    schoolIds,
  ) =>
  async (dispatch) => {
    try {
      const res = await api.get(
        `/assessmentresults/chart1/${year}/${benchmarkID}/${schoolID}/${gradeID}/${sectionID}/${studentID}/${teacherID}/${schoolIds}`,
      );
      dispatch({ type: GET_OVERALL_RESULTS_CHART, payload: res.data.data });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const getChartOverallByAssessmentResults =
  (
    year,
    benchmarkID,
    schoolID,
    gradeID,
    sectionID,
    studentID,
    teacherID,
    schoolIds,
  ) =>
  async (dispatch) => {
    try {
      const res = await api.get(
        `/assessmentresults/chart2/${year}/${benchmarkID}/${schoolID}/${gradeID}/${sectionID}/${studentID}/${teacherID}/${schoolIds}`,
      );
      dispatch({
        type: GET_OVERALL_RESULTS_BY_ASSESSMENT_CHART,
        payload: res.data.data,
      });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const getChartOverallProgression =
  (
    year,
    benchmarkID,
    schoolID,
    gradeID,
    sectionID,
    studentID,
    teacherID,
    schoolIds,
  ) =>
  async (dispatch) => {
    try {
      const res = await api.get(
        `/assessmentresults/chart3/${year}/${benchmarkID}/${schoolID}/${gradeID}/${sectionID}/${studentID}/${teacherID}/${schoolIds}`,
      );
      dispatch({
        type: GET_OVERALL_RESULTS_PROGRESSION_CHART,
        payload: res.data.data,
      });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const getChartsOverallResults =
  (
    year,
    benchmarkID,
    schoolID,
    gradeID,
    sectionID,
    studentID,
    teacherID,
    schoolIds,
  ) =>
  async (dispatch) => {
    try {
      const res = await api.get(
        `/assessmentresults/charts1/${year}/${benchmarkID}/${schoolID}/${gradeID}/${sectionID}/${studentID}/${teacherID}/${schoolIds}`,
      );
      dispatch({ type: GET_OVERALL_RESULTS_CHARTS, payload: res.data.data });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const getChartsOverallByAssessmentResults =
  (
    year,
    benchmarkID,
    schoolID,
    gradeID,
    sectionID,
    studentID,
    teacherID,
    schoolIds,
  ) =>
  async (dispatch) => {
    try {
      const res = await api.get(
        `/assessmentresults/charts2/${year}/${benchmarkID}/${schoolID}/${gradeID}/${sectionID}/${studentID}/${teacherID}/${schoolIds}`,
      );
      dispatch({
        type: GET_OVERALL_RESULTS_BY_ASSESSMENT_CHARTS,
        payload: res.data.data,
      });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const getChartsOverallProgression =
  (
    year,
    benchmarkID,
    schoolID,
    gradeID,
    sectionID,
    studentID,
    teacherID,
    schoolIds,
  ) =>
  async (dispatch) => {
    try {
      const res = await api.get(
        `/assessmentresults/charts3/${year}/${benchmarkID}/${schoolID}/${gradeID}/${sectionID}/${studentID}/${teacherID}/${schoolIds}`,
      );
      dispatch({
        type: GET_OVERALL_RESULTS_PROGRESSION_CHARTS,
        payload: res.data.data,
      });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const getChartAverageScorePerBenchmarkCategory =
  (
    year,
    benchmarkID,
    schoolID,
    gradeID,
    sectionID,
    studentID,
    teacherID,
    schoolIds,
  ) =>
  async (dispatch) => {
    try {
      const res = await api.get(
        `/assessmentresults/chart4/${year}/${benchmarkID}/${schoolID}/${gradeID}/${sectionID}/${studentID}/${teacherID}`,
      );
      dispatch({
        type: GET_AVERAGE_SCORE_BENCHMARK_CATEGORY_CHART,
        payload: res.data.data,
      });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const getChartAverageScorePerBenchmarkCategory2 =
  (
    year,
    benchmarkID,
    schoolID,
    gradeID,
    sectionID,
    studentID,
    teacherID,
    schoolIds,
  ) =>
  async (dispatch) => {
    try {
      const res = await api.get(
        `/assessmentresults/chart4-2/${year}/${benchmarkID}/${schoolID}/${gradeID}/${sectionID}/${studentID}/${teacherID}`,
      );
      dispatch({
        type: GET_AVERAGE_SCORE_BENCHMARK_CATEGORY_CHART2,
        payload: res?.data?.data,
      });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const loadResultsList =
  (payload = {}) =>
  async (dispatch) => {
    const source = getCancelSource("loadResultsList");
    try {
      const res = await api.post(`/assessmentresults/all`, payload, {
        cancelToken: source.token,
      });
      dispatch({ type: GET_RESULTS, payload: res?.data?.data });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    } finally {
      clearCancelSource("loadResultsList", source);
    }
  };

export const loadPMResultsList = (studentID) => async (dispatch) => {
  try {
    const res = await api.get(`/assessmentresults/pm/student/${studentID}`);

    // Sorting was require as when setting the base and goal we always use the 0th index result, so if the first result has null TargetScore and BaseScore, the goal line won't be shown in the dashboard, even if there are other results with TargetScore and BaseScore not null. This is a temporary solution until we update the backend to return the results already sorted with non-null TargetScore and BaseScore first.
    const rawData = res?.data?.data || [];

    // Sort: objects with non-null TargetScore and BaseScore move to the front
    const sortedData = [...rawData].sort((a, b) => {
      const aHasScores = a.TargetScore !== null && a.BaseScore !== null;
      const bHasScores = b.TargetScore !== null && b.BaseScore !== null;

      if (aHasScores && !bHasScores) return -1; // 'a' comes first
      if (!aHasScores && bHasScores) return 1; // 'b' comes first
      return 0; // leave their order unchanged
    });
    dispatch({ type: GET_PMRESULTS, payload: sortedData });
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const deletePMResult =
  (resultId, studentID, categoryID = null) =>
  async (dispatch) => {
    try {
      const res = await api.delete(`/assessmentresults/pm/${resultId}`);
      dispatch(setAlert("Result Deleted Successfully", "success"));

      // Wait for the list to reload
      if (studentID) {
        await dispatch(loadPMResultsList(studentID));
      }

      return res;
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors && errors[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else {
        dispatch(setAlert("Error deleting result", "danger"));
      }
      throw error;
    }
  };

export const addPMGoal = (formData) => async (dispatch) => {
  try {
    const res = await api.post("/assessmentresults/pm/goal", formData);
  } catch (error) {
    console.log(error);
  }
};

export const updatePMGoal = (goalID, formData) => async (dispatch) => {
  try {
    const res = await api.put(`/assessmentresults/pm/goal/${goalID}`, formData);
  } catch (error) {
    console.log(error);
  }
};

export const addPMIntervention = (formData) => async (dispatch) => {
  try {
    const res = await api.post("/assessmentresults/pm/intervention", formData);

    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const updatePMIntervention =
  (interventionID, formData) => async (dispatch) => {
    try {
      const res = await api.put(
        `/assessmentresults/pm/intervention/${interventionID}`,
        formData,
      );
    } catch (error) {
      console.log(error);
    }
  };

export const deletePMIntervention = (interventionID) => async (dispatch) => {
  try {
    const res = await api.delete(
      `/assessmentresults/pm/intervention/${interventionID}`,
    );
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteResult = (resultId, schoolID) => async (dispatch) => {
  try {
    await api.delete(`/assessmentresults/${resultId}`);
    // dispatch(loadResultsList(schoolID));
    dispatch(setAlert("Result Deleted Successfully", "info"));
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const deleteMultipleResults =
  (resultIDs, filterData) => async (dispatch) => {
    try {
      await api.delete(`/assessmentresults/delete`, { data: resultIDs });
      dispatch(loadResultsList(filterData));
      dispatch(setAlert("Result Deleted Successfully", "info"));
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const setClassroom = (classroom) => (dispatch) => {
  dispatch({ type: GET_CLASSROOM, payload: classroom });
};

export const getClassroom = (id) => async (dispatch) => {
  try {
    const res = await api.post("/classrooms/get", {
      ClassroomID: parseInt(id),
    });
    console.log(res);
    dispatch({ type: GET_CLASSROOM, payload: res?.data?.data });
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const loadClassroomsList =
  (formData = {}) =>
  async (dispatch) => {
    const source = getCancelSource("loadClassroomsList");
    try {
      const res = await api.post("/classrooms/get", formData, {
        cancelToken: source.token,
      });
      dispatch({ type: GET_CLASSROOMSLIST, payload: res?.data?.data });
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    } finally {
      clearCancelSource("loadClassroomsList", source);
    }
  };

export const loadClassroomsStudentList = () => async (dispatch) => {
  try {
    const res = await api.post("/classrooms/students/get");
    dispatch({ type: GET_CLASSROOMSSTUDENTLIST, payload: res?.data?.data });
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const updateClassroom = (classroomId, formData) => async (dispatch) => {
  try {
    await api.put(`/classrooms/${classroomId}`, formData);
    dispatch(setAlert("Classroom Updated Successfully", "success"));
    dispatch(loadClassroomsList());
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const addClassroomStudent = (formData) => async (dispatch) => {
  try {
    await api.post("/classrooms/student", formData);
    dispatch(getClassroom(formData.ClassroomID));
    dispatch(setAlert("Student Added Successfully to Classroom", "success"));
  } catch (err) {
    const errors = err?.response?.data?.errors;

    if (errors) {
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error?.message, "danger")));
    }
  }
};

export const addClassroomStudents = (formData) => async (dispatch) => {
  try {
    const res = await api.post("/classrooms/students", formData);

    if (res.status === 200) {
      const classroomId = res?.data?.data?.classroomId;
      dispatch(getClassroom(classroomId));
      dispatch(loadClassroomsList());
      dispatch(setAlert("Students Added Successfully to Classroom", "success"));
    }
  } catch (err) {
    const errors = err?.response?.data?.errors;

    if (errors) {
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else return errors;
    }
  }
};

export const deleteClassroomStudent = (studentId) => async (dispatch) => {
  try {
    await api.delete(`/classrooms/student/${studentId}`);
    dispatch(loadClassroomsList());
    dispatch(setAlert("Student removed Successfully from class", "info"));
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const addClassroom = (formData) => async (dispatch) => {
  try {
    await api.post("/classrooms", formData);
    dispatch(loadClassroomsList());
    dispatch(setAlert("Classroom Added Successfully", "success"));
  } catch (err) {
    const errors = err?.response?.data?.errors;

    if (errors) {
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error?.message, "danger")));
    }
  }
};

export const finalizeAssessment = (formData) => async (dispatch) => {
  try {
    await api.post("/assessmentresults/finalize", formData);
    dispatch(loadClassroomsList());
    dispatch(setAlert("Assessment Finalized", "success"));
  } catch (err) {
    const errors = err?.response?.data?.errors;

    if (errors) {
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error?.message, "danger")));
    }
  }
};

export const deleteClassroom = (classroomId) => async (dispatch) => {
  try {
    await api.delete(`/classrooms/${classroomId}`);
    dispatch(loadClassroomsList());
    dispatch(setAlert("Classroom Deleted Successfully", "info"));
  } catch (error) {
    console.log(error);
    const errors = error?.response?.data?.errors;
    if (errors)
      if (errors?.[0]?.msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const deleteMultipleClassrooms =
  (classroomIds, filterData) => async (dispatch) => {
    try {
      await api.delete(`/classrooms/delete`, { data: classroomIds });
      dispatch(loadClassroomsList(filterData));
      dispatch(setAlert("Classroom Deleted Successfully", "info"));
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      if (errors)
        if (errors?.[0]?.msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
    }
  };

export const retrieveSchoolYears = (date) => async (dispatch) => {
  try {
    const res = await getSchoolYears(date);

    if (res) {
      dispatch({ type: GET_SCHOOL_YEARS, payload: res });
    }
  } catch (error) {
    console.log(error);
  }
};

export const clearSchoolYears = () => (dispatch) => {
  dispatch({ type: CLEAR_SCHOOL_YEARS });
};

export const clearUser = () => (dispatch) => {
  dispatch({ type: CLEAR_USER });
};

export const clearReport = () => (dispatch) => {
  dispatch({ type: CLEAR_REPORT });
};

export const clearCompareReport = () => (dispatch) => {
  dispatch({ type: CLEAR_COMPARE_REPORT });
};

export const clearResult = () => (dispatch) => {
  dispatch({ type: CLEAR_RESULT });
  dispatch(clearAssessmentResult());
};

export const clearResultList = () => (dispatch) => {
  dispatch({ type: CLEAR_RESULT_LIST });
  dispatch(clearAssessmentResult());
};
export const clearSchool = () => (dispatch) => {
  dispatch({ type: CLEAR_SCHOOL });
};

export const clearAssessment = () => (dispatch) => {
  dispatch({ type: CLEAR_ASSESSMENT });
};

export const clearClassroom = () => (dispatch) => {
  dispatch({ type: CLEAR_CLASSROOM });
};

export const clearAll = () => (dispatch) => {
  dispatch({ type: CLEAR_ADMIN });
  dispatch(clearAssessmentResult());
};

export const clearItems = () => (dispatch) => {
  sessionStorage.clear();
  dispatch({ type: CLEAR_ITEMS });
};
